import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

/**
 * Merkteken voor een onderdeel dat nog in ontwikkeling is.
 *
 * Eén component in plaats van drie losse spans, zodat het teken in de sidebar, het
 * Meer-paneel en de paginakop niet uit elkaar gaat lopen - juist bij zoiets kleins valt een
 * verschil in kleur of hoofdletter meteen op als slordigheid.
 *
 * Amber en niet het huisstijlblauw: blauw is in deze app de kleur van "hier ben je" en van
 * de knop die je moet hebben, en een waarschuwing hoort daar niet mee te concurreren.
 */

interface BetaBadgeProps {
  className?: string;
}

export const BetaBadge: React.FC<BetaBadgeProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <span
      className={clsx(
        'inline-flex flex-shrink-0 items-center rounded-full bg-amber-100 px-1.5 py-0.5',
        'text-[10px] font-semibold uppercase leading-none tracking-wide text-amber-800',
        className,
      )}
    >
      {t('badges.beta')}
    </span>
  );
};

export default BetaBadge;
